import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62e0d42e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = {
  key: 0,
  class: "headline"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = { class: "continer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Thanks for shopping with Kilimall."),
  /*#__PURE__*/_createElementVNode("p", null, "Please track package by your order number."),
  /*#__PURE__*/_createElementVNode("p", null, "Any questions please contact us via APP message.")
], -1))
const _hoisted_6 = { class: "queryNo" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["orderQuery", {'orderQuery_pad':$setup.route.query.no_header==1}])
  }, [
    ($setup.route.query.no_header!=1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_van_icon, {
            name: "arrow-left",
            color: _ctx.fontColor,
            size: "22px",
            onClick: _ctx.goBack
          }, null, 8, ["color", "onClick"]),
          (_ctx.title != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Shipment Tracking Query "))
            : _createCommentVNode("", true),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createVNode(_component_van_field, {
          modelValue: $setup.orderNo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.orderNo) = $event)),
          class: "orderInput",
          clearable: "",
          autofocus: "",
          placeholder: "Your order number"
        }, null, 8, ["modelValue"]), [
          [_directive_focus]
        ]),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.getTrackCode_fn && $setup.getTrackCode_fn(...args)))
        }, "Check Now")
      ])
    ])
  ], 2))
}